import { Switch as HeadlessSwitch } from '@headlessui/react'

export default function Switch({ checked, onChange, label }) {
    return (
        <div className='flex items-center gap-3'>
            {label && <span className='text-sm text-gray-700 select-none'>{label}</span>}

            <HeadlessSwitch
                checked={checked}
                onChange={onChange}
                className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-200 ${
                    checked ? 'bg-yellow-500' : 'bg-gray-300'
                }`}
            >
                <span
                    aria-hidden='true'
                    className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition duration-200 ease-in-out ${
                        checked ? 'translate-x-7' : 'translate-x-1'
                    }`}
                />
            </HeadlessSwitch>
        </div>
    )
}
